module.exports = __webpack_public_path__ + "img/icon_bell_new_notification.098a6d3e.svg";